<template>
  <a-avatar
    v-bind="attrs"
    :class="[bem.b(), props.isTransform ? bem.is('transform') : '']"
    :src="avatarType === 'src' ? getSrc : ''"
  >
    <template v-if="avatarType === 'icon' || $slots.icon" #icon>
      <slot name="icon">
        <ll-icon v-bind="icon" />
      </slot>
    </template>
    <template v-if="avatarType === 'text'">
      <slot>{{ text }}</slot>
    </template>
  </a-avatar>
</template>
<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
import { computed, useAttrs } from 'vue'
import { AVATAR_IMG, avatarProps } from './avatar'

// 1.defineOptions
defineOptions({ name: 'LlAvatar' })

const attrs = useAttrs()

// 2.props/emits
const props = defineProps(avatarProps)

// 3.const
const bem = createNamespace('avatar')
const getSrc = computed(() => props.src || props.defaultSrc || AVATAR_IMG)
</script>
